import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
var useToastOnError = function (error, setSeeToast) {
    var t = useTranslation().t;
    useEffect(function () {
        if (error)
            showErrorToast(error, setSeeToast, t);
    }, [error]);
};
export var useProductCreationErrorHandling = function (_a) {
    var errorLookups = _a.errorLookups, errorProduct = _a.errorProduct, errorCreateProduct = _a.errorCreateProduct, errorUpdateProduct = _a.errorUpdateProduct, errorCampaign = _a.errorCampaign, errorCreateCampaign = _a.errorCreateCampaign, errorUpdateCampaign = _a.errorUpdateCampaign, errorLinkCampaign = _a.errorLinkCampaign, errorRecurrences = _a.errorRecurrences, errorCreateRecurrence = _a.errorCreateRecurrence, errorAccountTypes = _a.errorAccountTypes, errorCreateAccountType = _a.errorCreateAccountType, errorPlans = _a.errorPlans, errorAvatar = _a.errorAvatar, errorDelete = _a.errorDelete, setSeeToast = _a.setSeeToast;
    useToastOnError(errorLookups.sponsors, setSeeToast);
    useToastOnError(errorLookups.insuranceTypes, setSeeToast);
    useToastOnError(errorLookups.currencies, setSeeToast);
    useToastOnError(errorLookups.paymentModes, setSeeToast);
    useToastOnError(errorLookups.accountTypes, setSeeToast);
    useToastOnError(errorProduct, setSeeToast);
    useToastOnError(errorCreateProduct, setSeeToast);
    useToastOnError(errorUpdateProduct, setSeeToast);
    useToastOnError(errorCampaign, setSeeToast);
    useToastOnError(errorCreateCampaign, setSeeToast);
    useToastOnError(errorUpdateCampaign, setSeeToast);
    useToastOnError(errorLinkCampaign, setSeeToast);
    useToastOnError(errorRecurrences, setSeeToast);
    useToastOnError(errorCreateRecurrence, setSeeToast);
    useToastOnError(errorAccountTypes, setSeeToast);
    useToastOnError(errorCreateAccountType, setSeeToast);
    useToastOnError(errorPlans, setSeeToast);
    useToastOnError(errorAvatar, setSeeToast);
    useToastOnError(errorDelete, setSeeToast);
};
